export enum DanceManagerFeatureNameEnum {
  DANCE_EVENTS = 'DANCE_EVENTS',
  DANCE_EVENTS_TICKETS = 'DANCE_EVENTS_TICKETS',
  COURSES = 'COURSES',
  COURSE_PASSES = 'COURSE_PASSES',
  COURSE_SUBSCRIPTION = 'COURSE_SUBSCRIPTION'
}
